module.exports = __webpack_public_path__ + "img/partner_1_2x.46f034b8.png";